<template>
<v-card flat>
  <v-card-text>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>Podsumowanie płatnosci kredytowych</v-card-title>
            <v-card-text>
              <v-data-table  :headers="podsumowanieHeaders"
                            :no-data-text="'Brak danych'"
                            :loading="loading"
                            :options.sync="options"
                            :server-items-length="totalItems"
                            :items="podsumowanie"
                             :footer-props="{itemsPerPageOptions:[20,50,100,200,500]}"
                             class="elevation-1">
                <template v-slot:item="props">
                  <tr>
                    <td>{{props.item.typ}}</td>
                    <td>{{props.item.wartosc}}</td>
                    <td>{{dateTimeFormat(props.item.start_wizyty)}}</td>
                    <td>{{dateTimeFormat(props.item.data_wplaty)}}</td>
                    <td>{{props.item.dlugosc_wizyty > 0 ? props.item.dlugosc_wizyty : ''}}</td>
                    <td>{{props.item.terapeuta}}</td>
                    <td>
                      <v-icon small class="mr-2" @click="deleteWplata(props.item.id)" v-if="props.item.id > 0 && $can('do','POKO_KlienciKredyty_Usuwanie')" title="Usuń wpłate">fa-trash-alt</v-icon>
                    </td>
                  </tr>
                </template>
                <template slot="body.append">
                  <tr>
                    <th><b class="subtitle-1">Aktualne saldo: {{saldo}}</b></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                </template>
                <template v-slot:footer.prepend>
                  <v-btn
                      color="primary"
                      dark
                      class="ma-2"
                      @click="exportDataXLSX">
                    Zapisz Excel
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="6" align-self="end">
                    <v-text-field label="Wpłata" name="payAmount"
                                   min="0"
                                  v-model.number="payAmount"
                                  step="0.01" type="number" clearable>
                      >
                    </v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-container fluid>
                      <v-row>
                        <v-col cols="2" align-self="end">
                          <v-radio-group v-model="paymentType">
                            <v-radio :value="0"
                                     label="Gotówka"></v-radio>
                            <v-radio :value="1"
                                     label="Karta"></v-radio>
                            <v-radio :value="2"
                                     label="Przelew"></v-radio>
                          </v-radio-group>
                        </v-col>

                        <v-col cols="3" align-self="end">
                          <v-btn color="primary"
                                 @click="addPayment">
                            Dodaj płatność
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card-text>
</v-card>
</template>

<script>
import swal from "sweetalert";
import {clientService} from "@/services";
import * as dayjs from "dayjs";
const b64toBlob = (base64, type = 'application/octet-stream') =>
    fetch(`data:${type};base64,${base64}`).then(res => res.blob())

export default {
  name: "Kredyt",
  props: ["clientid"],
  data() {
    return {
      payAmount: 0,
      paymentType: 0,
      saldo: 0,
      podsumowanie: [],
      loading: false,
      podsumowanieHeaders: [
        {text: "Typ", value: "typ", sortable: false},
        {text: "Uznanie/Obciązanie", value: "wartosc", sortable: false},
        {text: "Start wizyty", value: "start_wizyty", sortable: false},
        {text: "Data wpłaty", value: "data_wplaty", sortable: false},
        {text: "Dlugosc wizyty", value: "dlugosc_wizyty", sortable: false},
        {text: "Terapeuta", value: "terapeuta", sortable: false},
        {text: "Akcje", value: "id", sortable: false},
      ],
      totalItems: 0,
      options: {},
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
  methods: {
    addPayment() {
      if(this.payAmount <= 0 )
      {
        this.showError("Podaj prawidłową wartośc wpłaty.");
        return
      }
      clientService.dodajWplateKredytu({
        paymentType: this.paymentType,
        payAmount: this.payAmount,
        clientID: this.clientid
      }).then(()=> {
        this.getData()
      }).catch(resp => {
        if(resp.response != null && resp.response.data != null && resp.response.data.error != null)
        {
          this.showError(resp.response.data.error.message)
        }
        else
        {
          this.showError('Błąd zapisu płatności kredytu')
        }
      })
    },
    dateTimeFormat(val)
    {
      if(val)
      {
        return dayjs(val).format('DD-MM-YYYY HH:mm')
      }
      return ''
    },
    deleteWplata(id)
    {
      swal({
        title: "Czy na pewno?",
        text:
            "Czy na pewno chcesz usunąć tą wpłate?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          clientService.deleteWplataKredytu(id)
              .then(() => {
                this.getData()
              }).catch(() => {
                this.showError("Nie można usunąć wpłaty");
          });
        }
      });
    },

    exportDataXLSX()
    {
      clientService.getWplatyKredytuXLSX(this.clientid).then(result=> {
        let b64 = result.data.result
        b64toBlob(b64).then(blob => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'WplatyKredytu_'+this.clientid+".xlsx";
          link.click();
          URL.revokeObjectURL(link.href);
        })
      }).catch((err) => {
        console.log(err)
        this.showError("Błąd generowania arkusza XLSX");
      })
    },
    getData()
    {
      const { page, itemsPerPage } = this.options
      this.loading = true
      clientService.getWplatyKredyty({
        ClientId: this.clientid,
        SkipCount: (page-1)* itemsPerPage,
        MaxResultCount: itemsPerPage
      }).then(result=> {
        this.podsumowanie = result.data.result.data.items
        this.totalItems = result.data.result.data.totalCount
        this.saldo = result.data.result.saldo
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.showError('Błąd pobierania wpłat kredytu')
      })

    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
  }
}
</script>

<style scoped>

</style>